import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router";

import {
  getMiljokontroll as getMiljokontrollAction,
  getMiljokontrollBilder as getMiljokontrollBilderActions,
} from "../../../../actions/miljokontrollerActions";
import Miljokontroll from "./Miljokontroll";

import { bypatruljen, juridisk } from "../../../../constants/roles";
import sitePaths from "../../../../constants/sitePaths";
import { authorized } from "../../../../utils/authorizationUtils";

const getMiljokontrollLinkUrl = (location, miljogebyrId, miljokontrollId) => {
  if (
    location.pathname.search(sitePaths.miljogebyrer.oversikt.detalj.matcher) ===
    0
  ) {
    return sitePaths.miljogebyrer.oversikt.detalj.miljokontroll.getUrl(
      miljogebyrId,
      miljokontrollId,
    );
  } else if (
    location.pathname.search(
      sitePaths.miljogebyrer.tilBehandling.detalj.matcher,
    ) === 0
  ) {
    return sitePaths.miljogebyrer.tilBehandling.detalj.miljokontroll.getUrl(
      miljogebyrId,
      miljokontrollId,
    );
  } else if (
    location.pathname.search(
      sitePaths.miljogebyrer.miljokontrolloversikt.miljogebyrer.detalj.matcher,
    ) === 0
  ) {
    return sitePaths.miljogebyrer.miljokontrolloversikt.miljogebyrer.detalj.miljokontroll.detalj.getUrl(
      miljogebyrId,
      miljokontrollId,
    );
  } else if (
    location.pathname.search(
      sitePaths.miljogebyrer.miljokontrolloversikt.detalj.miljogebyrer.detalj
        .matcher,
    ) === 0
  ) {
    return sitePaths.miljogebyrer.miljokontrolloversikt.detalj.getUrl(
      miljokontrollId,
    );
  } else if (
    location.pathname.search(sitePaths.klage.miljogebyrer.detalj.matcher) === 0
  ) {
    return sitePaths.klage.miljogebyrer.detalj.miljokontroll.getUrl(
      miljogebyrId,
      miljokontrollId,
    );
  }
  return null;
};

const buildGridTableRows = (
  miljogebyr,
  miljokontroll,
  miljokontrollerThumbnailBilder,
  location,
) => {
  if (!miljokontroll) {
    return [];
  }

  let kontrollnummer = miljokontroll.nummer
    ? miljokontroll.nummer.toString()
    : "";

  if (
    kontrollnummer &&
    authorized([
      bypatruljen.saksbehandleradmin,
      bypatruljen.saksbehandler,
      bypatruljen.driftleder,
      juridisk.saksbehandler,
    ])
  ) {
    const to = getMiljokontrollLinkUrl(
      location,
      miljogebyr.id,
      miljokontroll.id,
    );
    kontrollnummer = <Link to={to}>{kontrollnummer}</Link>;
  }

  const tjenestenummer = miljokontroll.tjenestenummer
    ? miljokontroll.tjenestenummer.toString()
    : "";
  const antallSammanhengendeDager =
    miljokontrollerThumbnailBilder &&
    miljokontrollerThumbnailBilder[miljokontroll.id]
      ? miljokontrollerThumbnailBilder[miljokontroll.id].length.toString()
      : "0";

  return [
    [
      { name: "Kontrollnummer", value: kontrollnummer, description: "" },
      { name: "Tjenestenummer", value: tjenestenummer, description: "" },
      {
        name: "Antall sammanhengende dager",
        value: antallSammanhengendeDager,
        description: "",
      },
      { name: "Kommentar", value: miljokontroll.kommentar, description: "" },
    ],
  ];
};

export default function MiljokontrollContainer(ownProps) {
  const location = useLocation();
  const miljogebyr = useSelector((state) => state.miljogebyr);
  const miljokontroll = useSelector((state) => state.miljokontroll);
  const miljokontrollerThumbnailBilder = useSelector(
    (state) => state.miljokontrollerThumbnailBilder,
  );
  const dispatch = useDispatch();

  const gridTableRows = buildGridTableRows(
    miljogebyr,
    miljokontroll,
    miljokontrollerThumbnailBilder,
    location,
  );

  const getMiljokontroll = useCallback(
    (id) => dispatch(getMiljokontrollAction(id)),
    [dispatch],
  );
  const getMiljokontrollBilder = useCallback(
    (id, params) => dispatch(getMiljokontrollBilderActions(id, params)),
    [dispatch],
  );
  const miljokontrollToInitState = useCallback(
    () => dispatch({ type: "MILJOKONTROLL_TO_INIT_STATE" }),
    [dispatch],
  );

  return (
    <Miljokontroll
      gridTableRows={gridTableRows}
      getMiljokontroll={getMiljokontroll}
      getMiljokontrollBilder={getMiljokontrollBilder}
      miljokontrollToInitState={miljokontrollToInitState}
      {...ownProps}
    />
  );
}
